/**
 * Created by abbeymart on 2016-12-27.
 */
import type { RouteRecordRaw } from 'vue-router';

export const userRoutes: Array<RouteRecordRaw> = [
  {
    path: '/register',
    name: 'register',
    component: () => import('pages/central/user/McRegister.vue'),
    meta: {
      title: 'User Registration - Register New User Account',
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('pages/central/user/McLogin.vue'),
    meta: {
      title: 'User Login',
    },
  },
  {
    path: '/change/request',
    component: () => import('pages/central/user/ChangeRequest.vue'),
    meta: {
      title: 'User Requests',
    },
  },
  {
    path: '/verify/:email/:username/:token/:taskType',
    component: () => import('pages/central/user/ChangeTask.vue'),
    meta: {
      title: 'User Change Tasks',
    },
  },
  {
    path: '/password/reset/:email/:username/:token/:taskType',
    component: () => import('pages/central/user/ChangeTask.vue'),
    meta: {
      title: 'User Change Tasks - Password Reset',
    },
  },
  {
    path: '/change/email/:email/:username/:token/:taskType',
    component: () => import('pages/central/user/ChangeTask.vue'),
    meta: {
      title: 'User Change Tasks - Change Registered Email',
      requiresAuth: true,
    },
  },
  {
    path: '/get/username/:email/:username/:token/:taskType',
    component: () => import('pages/central/user/ChangeTask.vue'),
    meta: {
      title: 'User Change Tasks - Change Registered Email',
    },
  },
  {
    path: '/change/username/:email/:username/:token/:taskType',
    component: () => import('pages/central/user/ChangeTask.vue'),
    meta: {
      title: 'User Change Tasks - Change Registered Username',
      requiresAuth: true,
    },
  },
  {
    path: '/verifyUserRequest',
    name: 'verifyUserRequest',
    component: () => import('pages/central/user/VerifyUserRequest.vue'),
    meta: {
      title: 'Verify User Request',
    },
  },
  {
    path: '/resetPasswordRequest',
    name: 'resetPasswordRequest',
    component: () => import('pages/central/user/ResetPasswordRequest.vue'),
    meta: {
      title: 'Reset Password Request',
    },
  },
  {
    path: '/getUsernameRequest',
    name: 'getUsernameRequest',
    component: () => import('pages/central/user/GetUsernameRequest.vue'),
    meta: {
      title: 'Get (Recover) Username',
    },
  },
  {
    path: '/account',
    name: 'account',
    redirect: '/userAccount',
    component: () => import('pages/central/user/UserAccount.vue'),
    meta: {
      title: 'User Accounts Dashboard',
      requiresAuth: true,
    },
    children: [],
  },
  {
    path: '/users',
    name: 'users',
    redirect: '/userAccount',
    component: () => import('pages/central/user/UserAccount.vue'),
    meta: {
      title: 'User Accounts Dashboard',
      requiresAuth: true,
    },
    children: [],
  },
  {
    path: '/user',
    name: 'user',
    redirect: '/userAccount',
    component: () => import('pages/central/user/UserAccount.vue'),
    meta: {
      title: 'User Account Dashboard',
      requiresAuth: true,
    },
    children: [],
  },
  {
    path: '/userAccount',
    name: 'userAccount',
    redirect: '/userAccount/userList',
    component: () => import('pages/central/user/UserAccount.vue'),
    meta: {
      title: 'User Account Dashboard',
      requiresAuth: true,
    },
    children: [
      {
        path: 'userList',
        name: 'userList',
        component: () => import('pages/central/user/UserList.vue'),
        meta: {
          title: 'Users List',
          requiresAuth: true,
        },
      },
      {
        path: 'createUser',
        name: 'createUser',
        component: () => import('pages/central/user/CreateUser.vue'),
        meta: {
          title: 'Create New User Account (Admin-function)',
          requiresAuth: true,
        },
      },
      {
        path: 'updateUser/:itemId?/:updateTask?',
        name: 'updateUser',
        component: () => import('pages/central/user/UpdateUser.vue'),
        meta: {
          title: 'Update User Record',
          requiresAuth: true,
        },
      },
      {
        path: 'userNew',
        name: 'userNew',
        component: () => import('pages/central/user/UserNew.vue'),
        meta: {
          title: 'Create New User Account (Admin-function)',
          requiresAuth: true,
        },
      },
      {
        path: 'userProfile',
        name: 'userProfile',
        component: () => import('pages/central/user/UserProfile.vue'),
        meta: {
          title: 'Update User Profile',
          requiresAuth: true,
        },
      },
      {
        path: 'role',
        name: 'role',
        redirect: '/userAccount/role/list',
        component: () => import('pages/central/role/McRole.vue'),
        meta: {
          title: 'Role Assignment',
          requiresAuth: true,
        },
        children: [
          {
            path: 'list',
            name: 'roleList',
            component: () => import('pages/central/role/RoleList.vue'),
            meta: {
              title: 'Role Assignment List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'roleDetail',
            component: () => import('pages/central/role/RoleDetail.vue'),
            meta: {
              title: 'Role Assignment Detail',
              requiresAuth: true,
            },
          },
          {
            path: 'new',
            name: 'roleNew',
            component: () => import('pages/central/role/RoleNew.vue'),
            meta: {
              title: 'New Role Assignment',
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: 'changePassword',
        name: 'changePassword',
        component: () => import('pages/central/user/ChangePassword.vue'),
        meta: {
          title: 'Change Password',
          requiresAuth: true,
        },
      },
      {
        path: 'changeUsernameRequest',
        name: 'changeUsernameRequest',
        component: () => import('pages/central/user/ChangeUsernameRequest.vue'),
        meta: {
          title: 'Change Registered Username Request',
          requiresAuth: true,
        },
      },
      {
        path: 'changeEmailRequest',
        name: 'changeEmailRequest',
        component: () => import('pages/central/user/ChangeEmailRequest.vue'),
        meta: {
          title: 'Change Registered Email Request',
          requiresAuth: true,
        },
      },
      {
        path: 'contact',
        name: 'myContact',
        redirect: '/userAccount/contact/list',
        component: () => import('pages/central/user/contact/UserContact.vue'),
        meta: {
          title: 'Contacts management',
          requiresAuth: true,
        },
        children: [
          {
            path: 'list',
            name: 'userContactList',
            component: () => import('pages/central/user/contact/ContactList.vue'),
            meta: {
              title: 'My [User] Contacts List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'myContactDetail',
            component: () => import('pages/central/user/contact/ContactDetail.vue'),
            meta: {
              title: 'My [User] Contact Details',
              requiresAuth: true,
            },
          },
          {
            path: 'new',
            name: 'myContactNew',
            component: () => import('pages/central/user/contact/ContactNew.vue'),
            meta: {
              title: 'New Contact',
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: 'address',
        name: 'myAddress',
        redirect: '/userAccount/address/list',
        component: () => import('pages/central/user/address/UserAddress.vue'),
        meta: {
          title: 'My Addresses',
          requiresAuth: true,
        },
        children: [
          {
            path: 'list',
            name: 'myAddressList',
            component: () => import('pages/central/user/address/AddressList.vue'),
            meta: {
              title: 'User Addresses List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'myAddressDetail',
            component: () => import('pages/central/user/address/AddressDetail.vue'),
            meta: {
              title: 'Address Details',
              requiresAuth: true,
            },
          },
          {
            path: 'new',
            name: 'myAddressNew',
            component: () => import('pages/central/user/address/AddressNew.vue'),
            meta: {
              title: 'New User Address',
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: 'phone',
        name: 'myPhone',
        redirect: '/userAccount/phone/list',
        component: () => import('pages/central/user/phone/UserPhone.vue'),
        meta: {
          title: 'Phones',
          requiresAuth: true,
        },
        children: [
          {
            path: 'list',
            name: 'myPhoneList',
            component: () => import('pages/central/user/phone/PhoneList.vue'),
            meta: {
              title: 'Phones List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'myPhoneDetail',
            component: () => import('pages/central/user/phone/PhoneDetail.vue'),
            meta: {
              title: 'Phone Details',
              requiresAuth: true,
            },
          },
          {
            path: 'new',
            name: 'myPhoneNew',
            component: () => import('pages/central/user/phone/PhoneNew.vue'),
            meta: {
              title: 'New User Phone',
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: 'app',
        name: 'userApp',
        redirect: '/userAccount/app/list',
        component: () => import('pages/central/user/app/UserApp.vue'),
        meta: {
          title: 'User-Application Assignment',
          requiresAuth: true,
        },
        children: [
          {
            path: 'list',
            name: 'userAppList',
            component: () => import('pages/central/user/app/UserAppList.vue'),
            meta: {
              title: 'User-Application Assignment List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'userAppDetail',
            component: () => import('pages/central/user/app/UserAppDetail.vue'),
            meta: {
              title: 'User-Application Assignment Detail',
              requiresAuth: true,
            },
          },
          {
            path: 'new',
            name: 'userAppNew',
            component: () => import('pages/central/user/app/UserAppNew.vue'),
            meta: {
              title: 'New User-Application Assignment',
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: 'sub/role',
        name: 'userRole',
        redirect: '/userAccount/sub/role/list',
        component: () => import('pages/central/user/role/UserRole.vue'),
        meta: {
          title: 'User-Role Assignment',
          requiresAuth: true,
        },
        children: [
          {
            path: 'list',
            name: 'userRoleList',
            component: () => import('pages/central/user/role/UserRoleList.vue'),
            meta: {
              title: 'User-Role Assignment List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'userRoleDetail',
            component: () => import('pages/central/user/role/UserRoleDetail.vue'),
            meta: {
              title: 'User-Role Assignment Detail',
              requiresAuth: true,
            },
          },
          {
            path: 'new',
            name: 'userRoleNew',
            component: () => import('pages/central/user/role/UserRoleNew.vue'),
            meta: {
              title: 'New User-Role Assignment',
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: 'email',
        name: 'userEmail',
        redirect: '/userAccount/email/list',
        component: () => import('pages/central/user/email/UserEmail.vue'),
        meta: {
          title: 'User-Email Assignment',
          requiresAuth: true,
        },
        children: [
          {
            path: 'list',
            name: 'userEmailList',
            component: () => import('pages/central/user/email/UserEmailList.vue'),
            meta: {
              title: 'User-Email Assignment List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'userEmailDetail',
            component: () => import('pages/central/user/email/UserEmailDetail.vue'),
            meta: {
              title: 'User-Email Assignment Detail',
              requiresAuth: true,
            },
          },
          {
            path: 'new',
            name: 'userEmailNew',
            component: () => import('pages/central/user/email/UserEmailNew.vue'),
            meta: {
              title: 'New User-Email Assignment',
              requiresAuth: true,
            },
          },
        ],
      },
    ],
  },
];
